import { render, staticRenderFns } from "./RecommendationPostTeaser.vue?vue&type=template&id=272223a5&scoped=true&"
import script from "./RecommendationPostTeaser.vue?vue&type=script&lang=js&"
export * from "./RecommendationPostTeaser.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationPostTeaser.vue?vue&type=style&index=0&id=272223a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272223a5",
  null
  
)

export default component.exports